export enum ESyncLogsTabs {
    logs = "logs",
}


export enum EFastDraftRelaticsSyncMethods {
    Read = "Read",
    Manage = "Manage"
}